<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :extra-bottom-padding="true">
      <o-nav-bar
        title="Cambio-inschrijving"
        :has-back-button="true"
        :has-close-button="true"
        :is-overlay="true"
      />
      <o-section-header title="MOBIB-kaart">
        <template #right>
          <o-icon icon="info" @click.native="showOverlay('info')" />
        </template>
      </o-section-header>
      <o-section>
        <p>
          Je kan je MOBIB-kaart gebruiken om de auto te openen als er geen
          mobiele dataverbinding beschikbaar is.
        </p>
        <p>
          Kies een kaart die je wil koppelen aan je Cambio-registratie of sla
          deze stap over.
        </p>
        <o-select-input icon="mobib" initial="placeholder">
          <option value="placeholder" disabled selected>
            Kies een MOBIB-kaart
          </option>
          <option value="optie1">
            My red MOBIB card
          </option>
          <option value="optie2">Green card</option>
          <option value="optie3">
            My friend's MOBIB card
          </option>
        </o-select-input>
      </o-section>
      <o-section>
        <o-text-input label="Kaartnummer" value="1234 5678 9012 3456" />
      </o-section>
      <o-section>
        <o-text-input label="Serienummer" />
      </o-section>
      <o-overlay ref="info" title="Informatie over MOBIB">
        <template #form>
          <o-mobib-info />
        </template>
      </o-overlay>
    </o-view>
    <o-pay-button
      label="Voeg nieuwe kaart toe"
      to="/sales/car/cambio/onboarding/mobib-new"
      :secondary="true"
    />
    <o-pay-button
      label="Volgende"
      to="/sales/car/cambio/onboarding/mobib-picture"
    />
  </o-view>
</template>

<script>
import OHeaderImage from '@/components/OHeaderImage.vue'
import OPayButton from '@/components/OPayButton.vue'
import OStarRating from '@/components/OStarRating.vue'
import OMobibInfo from '@/components/overlays/OMobibInfo.vue'
export default {
  name: 'CambioCurrent',
  components: {
    OMobibInfo,
    OHeaderImage,
    OPayButton,
    OStarRating
  },
  data() {
    return {
      pin: '• • • •'
    }
  },
  methods: {
    showPin() {
      this.pin = '4321'
    }
  }
}
</script>
